// FIXME: Prototyp; mit den Funktionen registerForm und vendorSettingsForm konsolidieren

mp.formgroupVisibility = {
    watcher: [],
    visible: [],
    invisible: [],

    init: function () {
        $('[data-formgroup-visibility]').each(function () {
            var config = $(this).data('formgroup-visibility');
            var id = 'mpFgv_' + Math.floor((Math.random() * 9999) + 1000);

            if (typeof (config.visible) !== 'undefined') {
                $(this).attr('id', id);
                mp.formgroupVisibility.visible.push({id: id, config: config.visible});
                for (var i in config.visible) {
                    if ($.inArray(i, mp.formgroupVisibility.watcher) === -1) {
                        mp.formgroupVisibility.watcher.push(i);
                        $(document).on('change', i, mp.formgroupVisibility.update);
                    }
                }
            }

            if (typeof (config.invisible) != 'undefined') {
                $(this).attr('id', id);
                mp.formgroupVisibility.invisible.push({id: $(this).attr('id'), config: config.invisible});
                for (var i in config.invisible) {
                    if ($.inArray(i, mp.formgroupVisibility.watcher) === -1) {
                        mp.formgroupVisibility.watcher.push(i);
                        $(document).on('change', i, mp.formgroupVisibility.update);
                    }
                }
            }
        });

        if (mp.formgroupVisibility.watcher.length > 0) {
            mp.formgroupVisibility.update();
        }
    },

    update: function (ev) {
        var ref = null;
        var conditions = 0, conditionsTrue = 0;

        for (var i in mp.formgroupVisibility.visible) {
            ref = mp.formgroupVisibility.visible[i];
            conditions = 0, conditionsTrue = 0;
            for (var z in ref.config) {
                conditions++;
                if ($(z).attr('type') === 'checkbox') {
                    if (ref.config[z] === true && $(z).is(':checked') || ref.config[z] === false && !$(z).is(':checked')) {
                        conditionsTrue++;
                    }
                } else if ($(z).attr('type') === 'radio') {
                    if ($(z).filter(':checked').val() == ref.config[z]) {
                        conditionsTrue++;
                    }
                } else if ($.inArray($(z).val(), ref.config[z]) > -1) {
                    conditionsTrue++;
                }
            }
            if (conditionsTrue === conditions) {
                $('#' + ref.id).removeClass('d-none');
            } else {
                $('#' + ref.id).addClass('d-none');
            }
        }

        for (var i in mp.formgroupVisibility.invisible) {
            ref = mp.formgroupVisibility.invisible[i];
            conditions = 0, conditionsTrue = 0;
            for (var z in ref.config) {
                conditions++;
                if ($(z).attr('type') === 'checkbox') { // FIXME: ein bisschen ein Logikproblem ;)
                    if (ref.config[z] === true && $(z).is(':checked') || ref.config[z] === false && !$(z).is(':checked')) {
                        conditionsTrue++;
                    }
                } else if ($(z).attr('type') === 'radio') {
                    if ($(z).filter(':checked').val() == ref.config[z]) {
                        conditionsTrue++;
                    }
                } else if ($.inArray($(z).val(), ref.config[z]) > -1) {
                    conditionsTrue++;
                }
            }
            if (conditionsTrue === conditions) {
                $('#' + ref.id).addClass('d-none');
            } else {
                $('#' + ref.id).removeClass('d-none');
            }
        }

        // aktuell nur für fieldsets
        $('.mpCollapsable').each(function () {
            $(this).removeClass('d-none');
            if ($(this).find('.form-group:visible').length === 0) {
                $(this).addClass('d-none');
            }
        });
    }
};

$(document).ready(function () {
    mp.formgroupVisibility.init();
});
